import React, { FC } from "react";
import { BsInfoCircle } from "react-icons/all";

import Panel from "./Panel";

const DescriptionPanel: FC = () => {
  return (
    <Panel
      initiallyDeployed
      title={
        <>
          <BsInfoCircle className="text-muted" /> Description
        </>
      }
    >
      <p>
        This map represents the community of Twitter users in connection with the topic of eDNA.
</p>
<p>
A first set of accounts was collected by searching for keywords "eDNA" and "metabarcoding" in the users' biography. Then, the network was expanded by collecting all the accounts followed by at least five users of this initial set. Finally, the list was refined to keep only the users who tweeted or retweeted about eDNA or metabarcoding more than three times in their 100 last contributions.
</p>
<p>
This resulted in a very dense network of 891 accounts. Only the symetric links (accounts follow each other) are represented. The size of the nodes are related to the number of incident edges. Colors delineate sub-community clusters detected algorithmically.
      </p>
      
      <p>
Data were collected and processed with R and the javascript app is powered by sigma.js.
      </p>
      
            <p>
Crafted by <a href="https://twitter.com/FrancoisKeck" target="_blank">@FrancoisKeck</a> in November 2021. Data are not automatically updated.
      </p>
    </Panel>
  );
};

export default DescriptionPanel;
